import React from 'react';
import { Typography, Icon } from '@mui/material';
import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  StyledDialogActions,
  OutlineButton,
  DangerButton,
  CloseButton
} from '../shared/modalStyles';

export interface DisconnectModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const DisconnectModal: React.FC<DisconnectModalProps> = ({
  onConfirm,
  onCancel
}) => {
  return (
    <StyledDialog
      open={true}
      onClose={onCancel}
      aria-labelledby="disconnect-dialog-title"
      aria-describedby="disconnect-dialog-description"
    >
      <StyledDialogTitle id="disconnect-dialog-title">
        ¿Seguro quieres desconectar?
        <CloseButton
          onClick={onCancel}
          aria-label="Close modal"
        >
          <Icon className="icon icon-close" sx={{ fontSize: '12px' }} />
        </CloseButton>
      </StyledDialogTitle>
      <StyledDialogContent>
        <Typography
          id="disconnect-dialog-description"
          fontSize="14px"
        >
          Se perderá la conexión establecida con tu línea de WhatsApp Business
        </Typography>
      </StyledDialogContent>
      <StyledDialogActions>
        <OutlineButton
          variant="outlined"
          onClick={onCancel}
        >
          Cancelar
        </OutlineButton>
        <DangerButton
          variant="contained"
          onClick={onConfirm}
        >
          Desconectar
        </DangerButton>
      </StyledDialogActions>
    </StyledDialog>
  );
};